module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Medium-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Medium-webfont.woff
// module id = 1634
// module chunks = 0